const LineItemIndex = ((jQuery) => {
  'use strict';

  const $auditsTreeTable = jQuery('#line-item-product');
  if ($auditsTreeTable.length === 0) {
    return;
  }

  const $productId = $('#product_id');
  const $table = $('#line-item-product');
  let rowsSelected = [];
  let datatable;

  const initproductsTable = () => {
    if ($productId.val() !== '') {
      rowsSelected = $productId.val().split(',');
    }

    datatable = $table.DataTable({
      language: {
        url: '/vendor/datatables/' + AppLocale + '.json'
      },
      ordering: false,
      createdRow: function (row, data, index) {
        if ($.inArray(data[0], rowsSelected) !== -1) {
          $('td', row).eq(0).addClass('selected');
          var trSelected = $('td', row).eq(0).closest('tr');
          trSelected.addClass('selected');
        }
      },
      stateSave: true,
      columnDefs: [{
        orderable: false,
        targets: 0,
        className: 'dt-body-center align-middle text-center',
        render: function (data, type, full, meta) {
          return '<input type="checkbox" class="custom-checkbox">';
        }
      }],

      'rowCallback': function (row, data, dataIndex) {
        // Get row ID
        var rowId = data[0];
        // If row ID is in the list of selected row IDs
        if ($.inArray(rowId, rowsSelected) !== -1) {
          $(row).find('input[type="checkbox"]').prop('checked', true);
          $(row).addClass('selected');
        }
      }
    });

    $('#save-selection-product').on('click', function (e) {
      $('#product_id')
          .val(rowsSelected.filter(element => element !== ''))
          .change()
          .valid();
      $('#line-item-product-modal').modal('toggle');
    });

    // Handle click on checkbox
    $('#line-item-product tbody').on('click', 'input[type="checkbox"]', function (e) {
      var $row = $(this).closest('tr');

      // Get row data
      var data = datatable.row($row).data();

      // Get row ID
      var rowId = data[0];
      // Determine whether row ID is in the list of selected row IDs
      var index = $.inArray(rowId, rowsSelected);

      // If checkbox is checked and row ID is not in list of selected row IDs
      if (this.checked && index === -1) {
        rowsSelected.push(rowId);

        // Otherwise, if checkbox is not checked and row ID is in list of selected row IDs
      } else if (!this.checked && index !== -1) {
        rowsSelected.splice(index, 1);
      }

      if (this.checked) {
        $row.addClass('selected');
      } else {
        $row.removeClass('selected');
      }

      // Prevent click event from propagating to parent
      e.stopPropagation();
    });

    $('#line-item-product').on('click', 'tbody td, thead th:first-child', function (e) {
      $(this).parent().find('input[type="checkbox"]').trigger('click');
    });

    // Handle change event for "Show selected records" control
    $('#ctrl-show-selected').on('change', function () {
      var val = $(this).val();
      // If all records should be displayed
      if (val === 'all') {
        $.fn.dataTable.ext.search.pop();
        datatable.draw();
      }

      // If selected records should be displayed
      if (val === 'selected') {
        $.fn.dataTable.ext.search.pop();
        $.fn.dataTable.ext.search.push(
          function (settings, data, dataIndex) {
            return !!($(datatable.row(dataIndex).node()).hasClass('selected'));
          }
        );
        datatable.draw();
      }
    });

  };

  // Handle manual product id input fill sync with datatable checked items
  $productId.change(function () {

    rowsSelected = $productId.val().replace(/\s/g, '').split(',');
    let selectedItemsFromInput = [];

    datatable.rows().every(function (rowIdx) {
      const row = datatable.row(rowIdx);
      const data = this.data();
      const rowId = data[0];
      const $row = row.nodes().toJQuery();
      const checkbox = $row.find('input[type="checkbox"]');

      if (rowsSelected.includes(rowId)) {
        checkbox.prop('checked', true);
        $row.addClass('selected');
        selectedItemsFromInput.push(rowId)

      } else {
        checkbox.prop('checked', false);
        $row.removeClass('selected')
      }
    });

    $('#ctrl-show-selected').val('all').change()
    datatable.draw();

    if (rowsSelected.length > selectedItemsFromInput.length) {
      let differences = rowsSelected.filter(x => !selectedItemsFromInput.includes(x));
      console.log(differences);
      differences.forEach(invalidId => {
        if(invalidId === '') {
          return;
        }
        toastr.error('ID Produit ' + invalidId + ' iconnu, veuillez vérifier votre saisie');
      });
    }
  });
  
  jQuery(() => {
    initproductsTable();
  });

})(jQuery);
